import styled from 'styled-components';

export const ActiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.4rem;
  user-select: none;
`;

export const ActiveHeader = styled.div`
  display: flex;
  align-items: center;

  Button {
    width: 5.4rem;
    height: 1.6rem;
    margin-left: 1rem;

    :hover:enabled {
      color: #dfd;
    }
  }
`;

export const ActiveHeaderText = styled.span`
  display: flex;
  align-items: center;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.2rem;

  cursor: pointer;
  color: #212326;
`;

export const PassiveContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.4rem;
  height: 1.6rem;

  font-family: 'Sora';
  font-style: normal;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.2rem;
  cursor: pointer;
  user-select: none;

  color: #212326;
`;
